<template>
  <v-app id="app" class="app-main">
    <router-view></router-view>
  </v-app>
</template>

<script>
  export default {}
</script>
<style src="sweetalert2/dist/sweetalert2.min.css"></style>
<style lang="stylus">
  @import './stylus/main'
  @import './assets/css/main.css'
</style>



// WEBPACK FOOTER //
// App.vue?304dc462